module.exports = __webpack_public_path__ + "static/media/spices_Thumb_1.42cf8281.jpg";